import { render } from "./SvgContainer.vue?vue&type=template&id=9863796a"
import script from "./SvgContainer.vue?vue&type=script&lang=js"
export * from "./SvgContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__